type getSelectedSystemSerialsForRequestProps = {
  selectedSystemSerials: Array<string>;
  allSystemSerials: Array<string>;
};

// Server treats [] as all user printers, historical included
export const getSelectedSystemSerialsForRequest = ({
  selectedSystemSerials,
  allSystemSerials,
}: getSelectedSystemSerialsForRequestProps): Array<string> => {
  const selected = new Set(selectedSystemSerials);
  return allSystemSerials.every(serial => selected.has(serial)) ? [] : selectedSystemSerials;
};
export const getDateForDayTimeframe = ({
  lowerDate,
  selectedDate,
  startDateLimit,
  endDateLimit,
}) => {
  // keep old logic running
  if (lowerDate) {
    return lowerDate;
  }
  // if no lowerDate, use selectedDate but in start and end date range
  if (selectedDate < startDateLimit) {
    return startDateLimit;
  }
  if (selectedDate > endDateLimit) {
    return endDateLimit;
  }
  return selectedDate;
};
